import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'nightfall_payments_disabled_info_closed';

function PaymentsDisabledInfo() {
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      setIsClosed(stored === 'true');
    } catch {
      setIsClosed(false);
    }
  }, []);

  const handleClose = (e) => {
    e.stopPropagation();
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {}
    setIsClosed(true);
  };

  if (isClosed) return null;

  return (
    <div 
      className="fixed left-0 w-64 bg-dark-surface border border-dark-border rounded-3xl m-2 md:m-5 p-6 shadow-xl h-fit z-50 transition-all duration-300 hidden md:block"
      style={{ top: 'calc(8rem + 220px + 2rem)' }}
    >
      <div className="mb-4 pb-3 border-b border-dark-border/50 flex items-center justify-between w-full">
        <h2 className="text-yellow-400/80 text-xs uppercase tracking-wider font-semibold m-0 py-0">Notice</h2>
        <button
          type="button"
          onClick={handleClose}
          className="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded text-white/50 hover:text-white/80 hover:bg-white/5"
          aria-label="Close notice"
        >
          <span className="material-icons text-[18px] leading-none align-middle">close</span>
        </button>
      </div>

      <div className="mb-4 flex items-center gap-2">
        <div className="w-8 h-8 rounded-xl bg-yellow-500/15 border border-yellow-500/30 flex items-center justify-center">
          <span className="material-icons text-yellow-400 text-[18px]">info</span>
        </div>
        <span className="text-base font-semibold text-white">Payments Disabled</span>
      </div>

      <div className="rounded-2xl bg-yellow-500/10 border border-yellow-500/25 p-3 mb-1">
        <p className="font-normal text-[11px] text-white/70 leading-relaxed m-0">
          Checkout is temporarily unavailable while we rebuild our systems. We are moving toward total independence from mainstream payment processors so adult games can have a lasting, safer home here. You can still browse everything in the meantime.
        </p>
      </div>
    </div>
  );
}

export default PaymentsDisabledInfo;
